import { useState } from 'react';
import { ButtonComponent, ButtonShape, ButtonType } from './button.component';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledFloatButtonLayout = styled.div.withConfig({
  displayName: "float-buttoncomponent__StyledFloatButtonLayout",
  componentId: "sc-y1wy2w-0"
})(["position:fixed;bottom:24px;right:24px;display:flex;flex-direction:column;gap:10px;width:80px;align-items:center;"]);
var StyledMenuButton = styled(ButtonComponent).withConfig({
  displayName: "float-buttoncomponent__StyledMenuButton",
  componentId: "sc-y1wy2w-1"
})(["width:70px;height:70px;transition:all 0.3s ease-in-out;svg{scale:1.2;transition:all 0.3s ease-in-out;}&:hover{scale:1.1;svg{scale:1.4;transition:all 0.3s ease-in-out;}}"]);
var StyledMenuItemButton = styled(ButtonComponent).withConfig({
  displayName: "float-buttoncomponent__StyledMenuItemButton",
  componentId: "sc-y1wy2w-2"
})(["width:60px;height:60px;transition:all 0.3s ease-in-out;&:hover{scale:1.1;}opacity:", ";"], function (props) {
  return props.disabled ? 0 : 1;
});
var StyledMenuItemLayout = styled.div.withConfig({
  displayName: "float-buttoncomponent__StyledMenuItemLayout",
  componentId: "sc-y1wy2w-3"
})(["position:fixed;bottom:110px;right:24px;display:flex;flex-direction:column;gap:10px;width:80px;align-items:center;"]);
export var FloatButtonComponent = function FloatButtonComponent(_ref) {
  var icon = _ref.icon,
      toolTipTitle = _ref.toolTipTitle,
      menuItem = _ref.menuItem;

  var _useState = useState(false),
      isOpenMenu = _useState[0],
      setIsIsOpenMenu = _useState[1];

  var onClickMenu = function onClickMenu() {
    setIsIsOpenMenu(!isOpenMenu);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledFloatButtonLayout, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        placement: "left",
        title: toolTipTitle,
        children: /*#__PURE__*/_jsx(StyledMenuButton, {
          shape: ButtonShape.circle,
          icon: icon,
          type: ButtonType.primary,
          onClick: onClickMenu
        })
      })
    }), /*#__PURE__*/_jsx(StyledMenuItemLayout, {
      children: menuItem.map(function (item) {
        return /*#__PURE__*/_jsx(Tooltip, {
          placement: "left",
          title: item.toolTipTitle,
          children: /*#__PURE__*/_jsx(StyledMenuItemButton, {
            shape: ButtonShape.circle,
            icon: item.icon,
            type: ButtonType.primary,
            disabled: !isOpenMenu,
            onClick: item.onClick
          })
        });
      })
    })]
  });
};